/*
 * @Author: bear
 * @Date:   2021-07-29 14:57:47
 * @Last Modified by:   bear
 * @Last Modified time: 2021-07-29 14:57:47
 */
function PublicFunction() {}

PublicFunction.prototype.checkPhoneNum = function (val) { 
  return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val);
};
PublicFunction.prototype.formatTime = function (date) { 
  let year = date.getFullYear()
  // let mouth = date.getMonth() + 1
  let mouth = (date.getMonth() < 9) ? '0' + (date.getMonth() + 1).toString() : date.getMonth() + 1

  let day = date.getDate() < 9 ? '0' + date.getDate() : date.getDate()
  return `${year}-${mouth}-${day} 00:00:00`
}


var publicMethod = new PublicFunction()
export default publicMethod; 